/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeviceAuthorizationDto
 */
export interface DeviceAuthorizationDto {
    /**
     * Current mode.
     * @type {string}
     * @memberof DeviceAuthorizationDto
     */
    mode?: DeviceAuthorizationDtoModeEnum;
    /**
     *  New mode to be applied (only used for Mode=AutomaticBasicAuth, waiting for the key to be sent to the charger)
     * @type {string}
     * @memberof DeviceAuthorizationDto
     */
    modeInProgress?: DeviceAuthorizationDtoModeInProgressEnum;
    /**
     * Obfuscated (first/last few chars only). If Mode=AutomaticBasicAuth or ManualBasicAuth, a hashed version of a 20 character unique secret key that has been sent to the charger. Null otherwise.
     * @type {string}
     * @memberof DeviceAuthorizationDto
     */
    authorizationKeyHashedObfuscated?: string;
    /**
     * Obfuscated (first/last few chars only). If Mode=AutomaticBasicAuth or ManualBasicAuth, the salt for AuthorizationKeyHashed. Null otherwise.
     * @type {string}
     * @memberof DeviceAuthorizationDto
     */
    authorizationKeySaltObfuscated?: string;
    /**
     * Obfuscated (first/last few chars only). If virtual passthrough device, and Mode=AutomaticBasicAuth or ManualBasicAuth, the key. Null otherwise.
     * @type {string}
     * @memberof DeviceAuthorizationDto
     */
    passthroughAuthorizationKeyObfuscated?: string;
    /**
     * Set to true if PassthroughAuthorizationKey is a 40 character hex representation of the secret key
     * @type {boolean}
     * @memberof DeviceAuthorizationDto
     */
    passthroughAuthorizationKeyIsHexString?: boolean;
    /**
     *
     * @type {Date}
     * @memberof DeviceAuthorizationDto
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof DeviceAuthorizationDto
     */
    updatedAt?: Date;
    /**
     * The time the ModeInProgress,AuthorizationKeyInProgress values were last applied to the device, and moved to Mode,AuthorizationKey.
     * @type {Date}
     * @memberof DeviceAuthorizationDto
     */
    appliedAt?: Date;
}

/**
 * @export
 */
export const DeviceAuthorizationDtoModeEnum = {
    LegacyBasicAuth: "LegacyBasicAuth",
    AutomaticBasicAuth: "AutomaticBasicAuth",
    ManualBasicAuth: "ManualBasicAuth",
    None: "None",
    Reject: "Reject",
} as const;
export type DeviceAuthorizationDtoModeEnum =
    (typeof DeviceAuthorizationDtoModeEnum)[keyof typeof DeviceAuthorizationDtoModeEnum];

/**
 * @export
 */
export const DeviceAuthorizationDtoModeInProgressEnum = {
    LegacyBasicAuth: "LegacyBasicAuth",
    AutomaticBasicAuth: "AutomaticBasicAuth",
    ManualBasicAuth: "ManualBasicAuth",
    None: "None",
    Reject: "Reject",
} as const;
export type DeviceAuthorizationDtoModeInProgressEnum =
    (typeof DeviceAuthorizationDtoModeInProgressEnum)[keyof typeof DeviceAuthorizationDtoModeInProgressEnum];

/**
 * Check if a given object implements the DeviceAuthorizationDto interface.
 */
export function instanceOfDeviceAuthorizationDto(
    value: object,
): value is DeviceAuthorizationDto {
    return true;
}

export function DeviceAuthorizationDtoFromJSON(
    json: any,
): DeviceAuthorizationDto {
    return DeviceAuthorizationDtoFromJSONTyped(json, false);
}

export function DeviceAuthorizationDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceAuthorizationDto {
    if (json == null) {
        return json;
    }
    return {
        mode: json["mode"] == null ? undefined : json["mode"],
        modeInProgress:
            json["modeInProgress"] == null ? undefined : json["modeInProgress"],
        authorizationKeyHashedObfuscated:
            json["authorizationKeyHashedObfuscated"] == null
                ? undefined
                : json["authorizationKeyHashedObfuscated"],
        authorizationKeySaltObfuscated:
            json["authorizationKeySaltObfuscated"] == null
                ? undefined
                : json["authorizationKeySaltObfuscated"],
        passthroughAuthorizationKeyObfuscated:
            json["passthroughAuthorizationKeyObfuscated"] == null
                ? undefined
                : json["passthroughAuthorizationKeyObfuscated"],
        passthroughAuthorizationKeyIsHexString:
            json["passthroughAuthorizationKeyIsHexString"] == null
                ? undefined
                : json["passthroughAuthorizationKeyIsHexString"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
        appliedAt:
            json["appliedAt"] == null ? undefined : new Date(json["appliedAt"]),
    };
}

export function DeviceAuthorizationDtoToJSON(
    value?: DeviceAuthorizationDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        mode: value["mode"],
        modeInProgress: value["modeInProgress"],
        authorizationKeyHashedObfuscated:
            value["authorizationKeyHashedObfuscated"],
        authorizationKeySaltObfuscated: value["authorizationKeySaltObfuscated"],
        passthroughAuthorizationKeyObfuscated:
            value["passthroughAuthorizationKeyObfuscated"],
        passthroughAuthorizationKeyIsHexString:
            value["passthroughAuthorizationKeyIsHexString"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
        appliedAt:
            value["appliedAt"] == null
                ? undefined
                : value["appliedAt"].toISOString(),
    };
}
